// extracted by mini-css-extract-plugin
export default {"card":"BankCard_card__BOSe2"};